import { render, staticRenderFns } from "./container-summary.vue?vue&type=template&id=6452ce09&scoped=true&"
import script from "./container-summary.vue?vue&type=script&lang=js&"
export * from "./container-summary.vue?vue&type=script&lang=js&"
import style0 from "./container-summary.vue?vue&type=style&index=0&id=6452ce09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6452ce09",
  null
  
)

export default component.exports